import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// 행동 목록 조회
export function getActivitiesFromMomthera({pid}) {
    return AxiosInterceptor({
        url: '/activities',
        method: 'get',
        params: {pid}
    })
}

// 구체화한 활동 조회
export function getActivitiesDetailFromMomthera({pid, sessionNum}) {
    return AxiosInterceptor({
        url: `/activities/detail/session/${sessionNum}`,
        method: 'get',
        params: {pid}
    })
}

// 사용자 활동 평가 조회
export function getActivitiesAssessmentFromMomthera({pid}) {
    return AxiosInterceptor({
        url: '/activities/assessment',
        method: 'get',
        params: {pid}
    })
}